import { render, staticRenderFns } from "./sellproduct.vue?vue&type=template&id=3640d8bc&"
import script from "./sellproduct.vue?vue&type=script&lang=js&"
export * from "./sellproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports